<template>
	<div class='knd-story' ref="story">
		<div class="mb-lg">
			<Intro />
		</div>

		<div v-if="selectedCompany">
			<div class="knd-wrapper-sm mb-lg">
				<div class="knd-select ta-center">
					<p>Jouw leverancier is</p> 

					<h3>{{selectedCompany.title}}</h3>
					
					<p>Dit zijn hun claims (maart 2024):</p> 

				</div>
			</div>
	
			<div class="mb-lg">
				<Swiper />
			</div>

			<Projecten />

			<Risicos />
			<Beoordeling />

			<div class="ta-center">
				<div class=" knd-scroll-to-top" @click="scrollToTop">
					<div class="knd-btn-wrapper">
					<span>
						<svg class='icon-scroll-top' viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="29.5" cy="29.5" r="29.5" fill="#F8F5F2"/>
							<path d="M27.5641 42.5122L27.5641 11L32.4359 11L32.4359 42.5122C33.6051 39.7317 35.5538 37.2911 38.282 35.1902C41.0103 33.0894 44.5829 31.8228 49 31.3902L49 36.0244C44.9077 36.4569 41.4 37.9398 38.4769 40.4732C35.5538 43.0683 33.5402 45.9106 32.4359 49L27.5641 49C26.4598 45.9106 24.4462 43.0683 21.5231 40.4732C18.6 37.9398 15.0923 36.4569 11 36.0244L11 31.3902C15.4171 31.8228 18.9897 33.0894 21.7179 35.1902C24.4462 37.2911 26.3949 39.7317 27.5641 42.5122Z" fill="#FF5362"/>
						</svg>
					</span>

					Check een andere energieleverancier
				</div>
				</div>
			</div>
			<div class="knd-paragraph">
				<Bronnen /> 
			</div>
		</div>
	</div>
</template>


<script setup>
  import { ref,computed } from "vue";
	import { useStore } from "vuex";

  import Intro from '@/story/intro/index.vue';
	import Swiper from './components/swiper';
	import Risicos from '@/story/risicos/index.vue';
	import Beoordeling from '@/story/beoordeling/index.vue';
	import Bronnen from '@/story/bronnen/index.vue';
	import Projecten from '@/story/projecten/index.vue';

	import './scss/index.scss';

	let store = useStore();

	let story = ref('story');
	const selectedCompany = computed(() => store.getters.selectedCompany)


	function scrollToTop() {
		// const element = document.getElementById("box");
		story.value.scrollIntoView({ behavior: "smooth" });

	}

</script>

<style lang="scss">
	.knd-scroll-to-top {
		display: inline-block;
		border-radius: 25px;
		padding: 1rem 2rem;
		background: var(--hot-coral);
		font-weight: bold;

		cursor: pointer;
		color: var(--off-white);

		.icon-scroll-top {
			height: 30px;
			transform: rotate(180deg);
		}

		.knd-btn-wrapper {
			pointer-events: none;
		}
	}
</style>

